<template>
  <div class="week-by-car-num">
    <div class="wrapper">
      <div style="font-weight: bold">周日均车辆运营情况统计</div>
      <WeekStatisticsTip style="margin-bottom: 20px;"/>
      <div class="header">
        <el-form :inline="true" label-width="60px">
          <el-form-item label="城市">
            <el-select v-if="arreData.length>0" v-model="formData.cityCode" placeholder="请选择城市">
              <el-option label="全部" value></el-option>
              <el-option v-for="(item,index) in arreData" :label="item.label" :value="item.value"
                         :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计周" label-width="75px">
            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>
          </el-form-item>
          <el-button style="margin-left:30px;" @click="onDebounceSearch">查询</el-button>
          <el-button style="margin-left:20px;" @click="showWeekDialog = true">导出</el-button>
          <el-button v-if="isShowBack" style="margin-left:20px;" @click="$router.push({
          path:'weeklyCarOperate'
          })">返回上级
          </el-button>
          <WeekDialog @on-command="onWeekDialogCommand" v-if="showWeekDialog"/>
        </el-form>
      </div>
      <el-table ref="singleTable" :data="tableData" :max-height="tableHeight" stripe style="width: 100%">
        <el-table-column type="index" label="序号" align="center" width="50" fixed="left"/>
        <el-table-column prop="provinceName" label="地区" align="center" fixed></el-table-column>
        <el-table-column v-for="(item1,index1) in tableCol" :label="item1.name" :key="index1" align="center">
          <el-table-column v-for="(item2,index2) in item1.children" :label="item2.name" :key="index2" align="center"
                           :min-width="150">
            <el-table-column v-if="curDate" align="center" :min-width="160">
              <template slot="header" slot-scope="scope">
                <div style="line-height: initial;padding:initial">{{ curDate }}</div>
                <div style="line-height: initial;padding:initial">({{ curDateRange }})</div>
              </template>
              <template slot-scope="scope">{{ scope.row[item2.prop] || 0 }}</template>
            </el-table-column>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>
        1.统计逻辑：统计不同燃料类型车辆在各运营省内的7天日均运营车辆数、运营里程数。
      </div>
      <div>
        2.统计频率：按周统计，每周日更新上周日至本周六数据。
      </div>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight.js' //请求汇总
import _ from 'lodash'
// import areaList from './components/areaList'

import WeekPopover from './components/weekPopover.vue'
import WeekDialog from './components/weekDialog.vue'
import Cookies from "js-cookie";
import First from "@/views/freight/weekByCarNum/index1.vue";
import WeekStatisticsTip from "@/components/WeekStatisticsTip.vue";

export default {
  name: 'week-by-car-num',
  components: {WeekPopover, WeekDialog, WeekStatisticsTip},
  data() {
    return {
      showWeekDialog: false,

      formData: {
        cityCode: '',
      },
      tableCol: [
        {
          name: '运营车辆数',
          children: [
            {name: '全部车辆', prop: 'runCarNum0'},
            {name: '柴油车辆', prop: 'runCarNum1'},
            {name: 'LNG车辆', prop: 'runCarNum2'},
            {name: '新能源车辆', prop: 'runCarNum3'},
          ],
        },
        {
          name: '运营里程',
          children: [
            {name: '全部车辆', prop: 'totalMile0'},
            {name: '柴油车辆', prop: 'totalMile1'},
            {name: 'LNG车辆', prop: 'totalMile2'},
            {name: '电车辆', prop: 'totalMile3'},
            {name: '氢车辆', prop: 'totalMile4'},
            {name: '其他车辆', prop: 'totalMile5'},
          ],
        },
      ],

      curDate: '',

      tableData: [],

      onDebounceSearch: _.debounce(this.getData, 500),
      curDateRange: '',
      currCode: '',
      isShowBack: true,
      arreData: []
    }
  },
  computed: {
    areaList() {
      let nerArr = JSON.parse(JSON.stringify(this.$store.getters.areaList))
      if (nerArr.length > 0) {
        nerArr.forEach(item => {
          if (item.provinceCode + '0000' === this.currCode) {
            nerArr = item.cityItem
          }
        })
      }
      return nerArr
    },
  },
  mounted() {
    this.currCode = this.$route.query.cityCode
    this.cityName = this.$route.query.cityName
    if (Cookies.get('userType') == '2') {
      this.isShowBack = false
    }
    this.getCiInter(this.currCode)
  },
  methods: {
    async getCiInter(code) {
      const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
      this.arreData = data
          .map(item => ({
            value: item.code,
            label: item.name,
          }));
    },
    getData() {
      let curSelectedWeek = this.$refs['weekPopoverRef'].curSelectedWeek
      if (!curSelectedWeek) {
        this.$message({
          message: '请选择周',
          type: 'warning',
        })
        return
      }
      let parms = {}
      if (Cookies.get('userType') == '2') {
        parms = {...curSelectedWeek, provinceCode: this.currCode, cityCode: this.formData.cityCode, type: 1}
      } else {
        parms = {...curSelectedWeek, provinceCode: this.currCode, cityCode: this.formData.cityCode, type: 2}
      }

      this.tableData = []
      http
          .getWeekCarOperate(parms)
          .then((e) => {
            if (200 != e.code) {
              this.$message({
                message: e.message || '数据获取出错',
                type: 'error',
              })
              return
            }

            if (e.data.length == 0) {
              this.tableData = []
              return;
            }

            let tmpData = e.data || []
            this.curDate = `${curSelectedWeek.year}年${curSelectedWeek.month}月第${curSelectedWeek.week}周`
            this.curDateRange = e.data[0].weekStart + '-' + e.data[0].weekEnd
            let tmpDataByProvinceCode = {}
            // console.log(this.areaList)
            // this.arreData = Cookies.get('userType') == '2'? this.areaList[0].cityItem:this.areaList
            tmpData.forEach((_) => {
              if ('all' === _.areaCode) {
                _.areaCode = 0
              }
              // let existProvince = [
              //   Cookies.get('userType') == '2'?{cityCode: this.areaList[0].provinceCode+'0000', cityName: this.areaList[0].provinceName}:{cityCode: this.currCode, cityName: this.cityName},
              //         ...this.arreData,
              // ].find((__) => {
              //   return __.cityCode == _.areaCode
              // })
              // if (existProvince) {
              if (!tmpDataByProvinceCode.hasOwnProperty(_.areaCode)) {
                tmpDataByProvinceCode[_.areaCode] = {
                  provinceName: _.provinceName,
                }
              }
              tmpDataByProvinceCode[_.areaCode] = {
                ...tmpDataByProvinceCode[_.areaCode],
                [`runCarNum${_.fuelType}`]: _.runCarNum,
                [`totalMile${_.fuelType}`]: Math.round(_.totalMile / 100) / 100,
              }
              // }
            })

            this.tableData = Object.values(tmpDataByProvinceCode).sort(
                (a, b) => b['runCarNum0'] - a['runCarNum0']
            )
          })
          .catch((err) => {
            console.error(err)
            this.curDate = ''
          })
    },

    onWeekPopOverCommand(params) {
      switch (params.type) {
        case 'default-week':
          this.getData()
          break
        default:
          break
      }
    },

    onWeekDialogCommand(params) {
      switch (params.type) {
        case 'ok':
          window.location.assign(http.getWeekCarOperateExport({
            ...params.data,
            provinceCode: this.currCode,
            cityCode: this.formData.cityCode,
            type: Cookies.get('userType') == '2' ? 1 : 2
          }))
          this.showWeekDialog = false
          break
        case 'close':
          this.showWeekDialog = false
          break
        default:
          break
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.wrapper {
  padding: 20px;
  background: #fff;
}
</style>
